import React , { useState } from 'react';
import ActionsTable from '../ActionsTable/ActionsTable';
import GridContainer from "./GridContainer";
import {ColorPicker} from '../../../libs/components/ColorPicker';
import Select from "react-select";

const getActionLinkByType = (actionType) => {
    switch(actionType){
        case 'phone':
            return 'tel:XXXXXX';
        case 'whatsapp':
            return 'https://wa.me/972XXXXXX/?text=היי , אני יוצר/ת קשר דרך כרטיס הביקור הדיגיטלי';
        default:
            return '';
    }
}

const getActionIconByType = (actionType) => {
    switch(actionType){
        case 'phone':
            return 'phone';
        case 'whatsapp':
            return 'whatsapp';
        default:
            return null;
    }
}

const getActionDescriptionByType = (actionType) => {
    switch(actionType){
        case 'whatsapp':
            return 'וואטספ';
        default:
            return null;
    }
}

export default function ActionsPanel({ 
    cardSettings, 
    actions,
    editCardSetting,
    removeAction,
    addCardAction, 
    updateAction, 
    setCardActions
}){

    const cardActionsColor = {hex : cardSettings.actionsSettings.color};
    const actionsFontColor = {hex: cardSettings.actionsSettings.fontColor};
    const defaultActionType = {value:'custom',label:'custom'};
    const [selectedActionType,setSelectedActionType] = useState(defaultActionType);
    
    const actionTypeOptions = [
      {value:'custom',label:'custom'},
      {value:'phone',label:'phone'},
      {value:'whatsapp',label:'whatsapp'}
    ]

    return(
        <div>
            <GridContainer>
                <label>Actions Color:</label>
                <ColorPicker color={cardActionsColor} onChangeCallback={(color)=>{
                // setActionsColor(color)
                editCardSetting("actionsSettings","color",color.hex)
                }}
                />
                <label>font Color:</label>
                <ColorPicker color={actionsFontColor} onChangeCallback={(color)=>{
                // setActionsColor(color)
                editCardSetting("actionsSettings","fontColor",color.hex)
                }}
                />
            </GridContainer>
            <div>
                <ActionsTable actions={actions} 
                onDelete={(id,position) => removeAction(id,position)}
                onRowUpdate={updateAction}
                onChange={(actions) => setCardActions(actions)}
                />
                <div style={{display:'flex'}}>
                <label>type:</label>
                <Select style={{width:150,color:'black'}} options={actionTypeOptions} value={selectedActionType} onChange={(selectedOption) => setSelectedActionType(selectedOption)}/>
                <button onClick={() => {
                    const actionToAdd = {
                        id: null, 
                        description: getActionDescriptionByType(selectedActionType.value), 
                        icon: getActionIconByType(selectedActionType.value),
                        link: getActionLinkByType(selectedActionType.value),
                        type: selectedActionType.value,
                        position: actions.length+1
                    }
                    addCardAction(actionToAdd);
                }}>add action</button>
                </div>
            </div>
        </div>
    )

}